import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from "@angular/router";
import { NavigationService } from "@core/navigation/navigation.service";
import { NotificationsService } from "@shared/components/notifications/notifications.service";
import { ProspectosRootService } from "@shared/services/app/prospectos-root.service";
import { forkJoin } from "rxjs";
@Injectable({
  providedIn: "root",
})
export class AppResolvers implements Resolve<any> {
  constructor(
    private _notificacionesService: NotificationsService,
    private _navigationService: NavigationService,
    private _prospectosRootService: ProspectosRootService
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    /* console.log('AppResolvers') */
    return forkJoin([
      this._notificacionesService.getAll(),
      this._navigationService.get()
      /* this._prospectosRootService.getAll(), */
    ]);
  }
}
